import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "game-view"
}
const _hoisted_2 = { class: "game-name" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  class: "bracketed"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href", "textContent"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href", "textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "DLC and other purchases", -1)
const _hoisted_13 = { class: "purchases-list" }
const _hoisted_14 = ["textContent"]

import { computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Actions, Mutations } from '@/store';
import { Game } from '@/models/game.model';
import { formatDate, formatPrice } from '@/core/filters';
import PurchaseItem from '@/components/purchases/PurchaseItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameView',
  setup(__props) {

const store = useStore();
const route = useRoute();

const item = computed<Game>(() => store.state.item);
const twitterLink = computed(
  () =>
    `https://twitter.com/search?q=%40soesahgaming%20%23${item.value.hashtag}&src=typd`,
);
onMounted(() => {
  if (!store.state.item) {
    store.dispatch(Actions.GetGameByName, route.params.title);
  }
});

onUnmounted(() => {
  store.commit(Mutations.SetViewItem, null);
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_unref(item))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", {
            textContent: _toDisplayString(_unref(item).name)
          }, null, 8, _hoisted_3),
          _createElementVNode("span", {
            class: _normalizeClass('icon icon-' + _unref(item).store),
            title: `${_unref(item).store}`
          }, null, 10, _hoisted_4)
        ]),
        _createElementVNode("h3", null, _toDisplayString(_unref(formatDate)(_unref(item).date)), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_unref(formatPrice)(_unref(item).price)) + " ", 1),
          (_unref(item).price != _unref(item).cost)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(formatPrice)(_unref(item).cost)) + " including DLC etc.", 1))
            : _createCommentVNode("", true)
        ]),
        (_unref(item).website)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createElementVNode("a", {
                href: _unref(item).website,
                textContent: _toDisplayString(_unref(item).website),
                target: "_new"
              }, null, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        (_unref(item).hashtag)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createElementVNode("a", {
                href: _unref(twitterLink),
                textContent: _toDisplayString('#' + _unref(item).hashtag),
                target: "_new"
              }, null, 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          textContent: _toDisplayString(_unref(item).developer)
        }, null, 8, _hoisted_10),
        (_unref(item).purchases && _unref(item).purchases.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(item).purchases, (purchase) => {
                  return (_openBlock(), _createBlock(PurchaseItem, {
                    purchase: purchase,
                    key: purchase.key,
                    links: false
                  }, null, 8, ["purchase"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          textContent: _toDisplayString(_unref(item).review)
        }, null, 8, _hoisted_14),
        _createVNode(_component_RouterLink, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Back")
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: '/game/' + _unref(item).url + '/edit'
        }, {
          default: _withCtx(() => [
            _createTextVNode("Edit")
          ]),
          _: 1
        }, 8, ["to"])
      ]))
    : _createCommentVNode("", true)
}
}

})